import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApi from 'hooks/useApi';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const PedidoitensAddPage = (props) => {
		const app = useApp();
	const api = useApi();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		prodid: yup.string().required().label("Produto"),
		qtde: yup.number().required().label("Qtde"),
		unit: yup.string().required().label("Unit"),
		validate: yup.string().nullable().label("Data de Validade"),
		ca: yup.string().nullable().label("CA")
	});
	
	//form default values
	const formDefaultValues = {
		prodid: '', 
		qtde: "1", 
		unit: "0", 
		validate: new Date(), 
		ca: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/pedidoitens/add`);
		}
	}
	
	//auto fill other inputs on prodid change
	async function prodidAutoFill(e, formik, index) {
		formik.handleChange(e);
		const val = e.target.value;
		const resp = await api.get(`components_data/pedidoitens_prodid_autofill?value=${val}`);
		const data = resp.data[0];
		if(data){
formik.setFieldValue('unit', data.venda);
formik.setFieldValue('validate', data.validade);
formik.setFieldValue('ca', data.ca);
		}
	};
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="PedidoitensAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Adicionar novo"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-12 col-12">
                                        Produto *
                                        <div> 
                                            <DataSource   apiPath="components_data/prodid_option_list"  >
                                                {
                                                ({ response }) => 
                                                <>
                                                <Dropdown  name="prodid"     optionLabel="label" optionValue="value" value={formik.values.prodid} onChange={(e)=>prodidAutoFill(e, formik)} options={response} label="Produto"  placeholder="Selecione um valor ..."  className={inputClassName(formik?.errors?.prodid)}   />
                                                <ErrorMessage name="prodid" component="span" className="p-error" />
                                                </>
                                                }
                                            </DataSource>
                                        </div>
                                    </div>
                                    <div className="md:col-3 col-12">
                                        Qtde *
                                        <div> 
                                            <InputText name="qtde"  onChange={formik.handleChange}  value={formik.values.qtde}   label="Qtde" type="number" placeholder="Entrar Qtde"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.qtde)} />
                                            <ErrorMessage name="qtde" component="span" className="p-error" />
                                        </div>
                                    </div>
                                    <div className="md:col-3 col-12">
                                        Unit *
                                        <div> 
                                            <InputText name="unit"  onChange={formik.handleChange}  value={formik.values.unit}   label="Unit" type="text" placeholder="Entrar Unit"        className={inputClassName(formik?.errors?.unit)} />
                                            <ErrorMessage name="unit" component="span" className="p-error" />
                                        </div>
                                    </div>
                                    <div className="md:col-3 col-12">
                                        Data de Validade 
                                        <div> 
                                            <Calendar name="validate" showButtonBar className={inputClassName(formik?.errors?.validate)} dateFormat="yy-mm-dd" value={formik.values.validate} onChange={formik.handleChange} showIcon        />
                                            <ErrorMessage name="validate" component="span" className="p-error" />
                                        </div>
                                    </div>
                                    <div className="md:col-3 col-12">
                                        CA 
                                        <div> 
                                            <InputText name="ca"  onChange={formik.handleChange}  value={formik.values.ca}   label="CA" type="text" placeholder="Entrar CA"     disabled   className={inputClassName(formik?.errors?.ca)} />
                                            <ErrorMessage name="ca" component="span" className="p-error" />
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label="Enviar" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
PedidoitensAddPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'pedidoitens',
	apiPath: 'pedidoitens/add',
	routeName: 'pedidoitensadd',
	submitButtonLabel: "Enviar",
	formValidationError: "O formulário é inválido",
	formValidationMsg: "Por favor, preencha o formulário",
	msgTitle: "Criar registro",
	msgAfterSave: "Registro adicionado com sucesso",
	msgBeforeSave: "Deseja Salvar os Dados Agora?",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default PedidoitensAddPage;
